module.exports = "<span>\r\n  {{ $ctrl.value | currency: undefined : $ctrl.fraction || $ctrl.defaultFraction }}\r\n</span>\r\n\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-currency/rw-currency.html
// module id = 1915
// module chunks = 0